/**
 * Handles the display of tooltips inside Bootstrap's `form-group`
 * @module form_group_tooltip
 */

// Marks the fieldset or form group that contains a tooltip
const SELECTOR = '.js-form-group-with-tooltip';
// Marks the container for the toggle
const SELECTOR_TOGGLE_CONTAINER = `
  legend:not(.js-form-group-with-tooltip__ignore),
  label:not(.js-form-group-with-tooltip__ignore),
  .js-form-group-with-tooltip__tooltip
`;
// Marks the tooltip itself
const SELECTOR_TOOLTIP = '.form-tooltip';

/**
 * @param {HTMLElement} scope Unused, just for matching the rest of the setup function structure
 *                            in case there's need to consolidate their lifecycle at some point
 * @param {HTMLElement} el The element within which there's a tooltip to setup
 */
function setupFormGroupTooltip(scope, el) {
  const tooltip = el.querySelector(SELECTOR_TOOLTIP);
  tooltip.classList.add('bcs-collapse');
  tooltip.classList.add('bcs-collapse--withArrow');
  const toggle = document.createElement('button');
  toggle.setAttribute('type', 'button');
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('data-toggle-class', 'is-visible');
  toggle.setAttribute('data-toggle-target', `#${tooltip.id}`);
  toggle.classList.add('tooltipToggle');
  toggle.classList.add('flex-none');
  toggle.classList.add('mr-2');
  toggle.innerHTML = `
    <span aria-hidden="true" class="tooltipToggle__visible">×</span>
    <span aria-hidden="true" class="tooltipToggle__hidden">?</span>
    <span class="sr-only">More info</span>`;
  // TODO: Figure out how to avoid vocalisation of toggles
  const container = el.querySelector(SELECTOR_TOGGLE_CONTAINER);
  container.classList.add('d-flex');
  container.classList.add('justify-content-between');
  container.classList.add('align-items-center');
  container.appendChild(toggle);
}

export default function setupFormGroupTooltips(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(widget => {
    setupFormGroupTooltip(el, widget);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/form_group_tooltip.js